import React from "react";
import PropTypes from "prop-types";

import Select from "react-select";
import FormStrings from "../utils/form_strings";
import ViewAndFilterHelpers from "../utils/view_and_filter_helpers";

class ViewType extends React.Component {
  onTypeChange = (e) => {
    this.props.onChange(e.value);

    this.props.onUpdate();
  }

  render() {
    const selectedTypeId = this.props.selectedViewTypeId;
    const selectedPrimaryType = ViewAndFilterHelpers.filterFromId(this.props.filterObjects, this.props.selectedPrimaryTypeId);
    const desalinationSelectedOption = !!this.props.selectedOptions.find((e) => e.label === "Seawater and brackish water desalination");

    const disabledOption = (e) => {
      if (!selectedPrimaryType) return true;

      const excluded = !!selectedPrimaryType.excluded_views.find((id) => id === e.id);
      const desalinationExcluded = desalinationSelectedOption && (e.label === "CAPEX - Regions" || e.label === "CAPEX - Technologies");

      return excluded || desalinationExcluded;
    };

    const viewTypes = this.props.viewObjects.map((e) => ({ value: e.id, label: e.label, isDisabled: disabledOption(e) }));
    const allowedViews = viewTypes.filter((e) => !e.isDisabled);
    const disabled = allowedViews.size === 0;

    return (
      <div>
        <h4>Breakdown by</h4>
        <Select
          classNamePrefix="Select"
          classNames={{ container: () => "Select__container" }}
          value={viewTypes.find(e => e.value === selectedTypeId) || null}
          name={FormStrings.viewTypeName}
          options={viewTypes}
          onChange={this.onTypeChange}
          isClearable={false}
          isDisabled={disabled}
        />
      </div>
    );
  }
}

ViewType.propTypes = {
  viewObjects: PropTypes.arrayOf(PropTypes.object),
  filterObjects: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  selectedPrimaryTypeId: PropTypes.string,
  selectedViewTypeId: PropTypes.number,
  onUpdate: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array.isRequired
};

export default ViewType;
